import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify, Analytics } from 'aws-amplify';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

import './assets/css/index.css';
import './assets/scss/styles.scss';
import './assets/scss/Timeline.scss';

import Ai2App from './Ai2App';
import { store } from './store';

try {
  const r = Amplify.configure({
    Auth: {
      // REQUIRED - Amazon Cognito Region
      region: 'ap-southeast-2',
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_ANALYTICS_IDENTITY_POOL_ID,
    },
    Analytics: {
      disabled: false,
      AWSPinpoint: {
        // Amazon Pinpoint App Client ID
        appId: process.env.REACT_APP_ANALYTICS_APP_ID,
        // Amazon service region
        region: 'ap-southeast-2',
        mandatorySignIn: false,
      },
    },
  });
} catch (e) {
  console.log('AMIPLIFY FAIL');
  console.log(e);
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Ai2App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
